let monacoPreloaded = false;

export const preloadMonaco = () => {
  if (monacoPreloaded || typeof window === 'undefined') return;

  const preload = () => {
    import('@monaco-editor/react').then(() => {
      import('monaco-editor/esm/vs/editor/editor.api.js').then(() => {
        monacoPreloaded = true;
      }).catch(() => {
        // silent fail - will load normally when needed
      });
    }).catch(() => {
      // silent fail - will load normally when needed
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(preload, { timeout: 2000 });
  } else {
    setTimeout(preload, 100);
  }
};

export const isMonacoPreloaded = () => monacoPreloaded;
